import { Paper } from '@mui/material'
import { FC } from 'react'
import { MyPaperProps } from './types'

export const MyPaper: FC<MyPaperProps> = ({ children }) => {
  return (
    <Paper sx={{ padding: '1rem', borderRadius: '1rem', mt: 3 }} elevation={0}>
      {children}
    </Paper>
  )
}
